import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'

// 游戏阶段状态
export enum GameStatusEnum {
  活动未开始 = 0,
  蓄力阶段 = 1,
  抢夺阶段 = 2,
}

// 第一名用户类型
interface KingUserType {
  id: number // 用户id
  name: string // 昵称
  zy_id: string // 靓号
  avatar: string // 头像
}

// 奖励类型
interface KingRewardType {
  mid: string
  coins: number // 金币
}

// 主接口返回数据类型
export interface HomePageType {
  start_date: string // 活动开始日期
  end_date: string // 活动结束日期
  min_round_num: number // 最少游戏轮次
  max_round_num: number // 最大游戏轮次
  inc_round_num: number // 每次增加的轮次
  status: GameStatusEnum // 游戏阶段状态
  jackpot_val: number // 奖池
  start_progress: number // 抢夺开启累积进度
  left_rounds: number // 剩余轮次
  king?: KingUserType // 当前第一名用户
  change_king_need: number // 抢夺王座需要的金额
  rocket_king_reward?: KingRewardType // 本次奖励
  settle_done?: boolean // 当前轮次round_no是否结算完成
}

interface KingStateType {
  homePage: HomePageType
  updateRound: boolean // 为true需要执行轮次变换动画
  ownId?: number // 当前用户id
}

const initialState: KingStateType = {
  homePage: null,
  updateRound: false,
}

// 玩法主接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=156930043
export const rocket_king_homepage = createAsyncThunk(
  '/live/game/rocket_king_homepage',
  async (arg: {game_round_no: string}, store: any) => {
    // const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/rocket_king_homepage',
      {
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 历史记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=156930046
export const rocket_king_records = async (arg: any) => {
  const resp = await http.post('/live/game/rocket_king_records', {
    ...window.store.getState().env.deviceinfo,
    limit: 10,
    page_size: 10,
    offset: 0,
    ...arg,
  })
  return resp.data.data
}

export const KingSlice = createSlice({
  name: 'King',
  initialState,
  reducers: {
    setOwnId: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        ownId: action.payload,
      })
    },
    setUpdateRound: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        updateRound: action.payload,
      })
    },
    setStatus: (state, action: PayloadAction<GameStatusEnum>) => {
      Object.assign(state, {
        ...state,
        homePage: {
          ...state.homePage,
          status: action.payload,
        },
      })
    },
    setJackpot_val: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        ...state,
        homePage: {
          ...state.homePage,
          jackpot_val: action.payload,
        },
      })
    },
    setStart_progress: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        ...state,
        homePage: {
          ...state.homePage,
          start_progress: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(rocket_king_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        homePage: {
          ...state.homePage,
          ...action.payload,
        },
      })
    })
  },
})
export default KingSlice.reducer
export const useKingState = () => {
  return useSelector((state) => state.King) as KingStateType
}
export const KingActions = KingSlice.actions
